import { render, staticRenderFns } from "./BaseInfoCard.vue?vue&type=template&id=4dd029ff&scoped=true"
var script = {}
import style0 from "./BaseInfoCard.vue?vue&type=style&index=0&id=4dd029ff&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dd029ff",
  null
  
)

export default component.exports